import React, { useContext, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
// import Home from "../layouts/home/index";
import Home from "../containers/home/index";
import { PayLoadCtx, RoleCtx } from "../lib/context";

import { API } from "aws-amplify";
import config from "../config.json";
import { OffLineAPI } from "../offline-auth/api";

var _API = config.isOffline ? OffLineAPI : API;

window.Cookies = require("js-cookie");

function querystring(name, url = window.location.href) {
  name = name.replace(/[[]]/g, "\\$&");
  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
  const results = regex.exec(url);

  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

const PublicRoute = ({ component: C, props: cProps, ...rest }) => {
  const { payload } = useContext(PayLoadCtx);
  const { role } = useContext(RoleCtx);
  const redirect = querystring("redirect");
  const referrer = querystring("ref");
  useEffect(() => {
    console.log("............................................................");
    const ref_coc = window.Cookies.get("inconsultreferrer");
    console.log("ref_coc..................", ref_coc, referrer);
    if (
      referrer &&
      (ref_coc === undefined || (ref_coc && ref_coc !== referrer))
    ) {
      window.Cookies.set("inconsultreferrer", referrer, {
        expires: 1,
        path: "",
      });

      let body = {
        // referral_url : window.location.href,
        userId: referrer,
        productCode: "INCONSULT",
      };

      _API
        .post("inaffiliateUser", "/referrerclicks", { body })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [referrer]);

  return (
    <Route
      {...rest}
      render={(props) =>
        payload ? (
          role === "CO" ? (
            <Redirect to="/consultant-dashboard" />
          ) : role === "U" ? (
            <Redirect to="/user-dashboard" />
          ) : role === "C" ? (
            <Redirect to="/corporate-dashboard" />
          ) : // : role === "CA" ? (
          //   <Redirect to="/admin-dashboard" />
          // )
          role === "SA" ? (
            <Redirect to="/dashboard" />
          ) : (
            <Home
              {...props}
              {...cProps}
              component={(props) => <C {...cProps} {...props} />}
            />
          )
        ) : (
          <Home
            {...props}
            {...cProps}
            component={(props) => <C {...cProps} {...props} />}
          />
        )
      }
    />
  );
};

export default PublicRoute;
